import type { IconSvgObject } from './types';

const SplineIcon: IconSvgObject = [
  ["circle", { cx: "18.9922", cy: "5", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "4.99219", cy: "19", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4.99219 17C4.99219 10.3726 10.3648 5 16.9922 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SplineIcon;
